import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { useSubscription } from '@/contexts/SubscriptionContext'; // Assuming this hook exists and provides trial_ends_at
import { X } from 'lucide-react'; // For the close button
import { Link } from 'react-router-dom';

const PremiumTrialExpiryBanner: React.FC = () => {
  const { subscription, subscriptionPlan } = useSubscription(); // Added subscriptionPlan
  const [isVisible, setIsVisible] = useState(false);
  const [remainingDays, setRemainingDays] = useState<number | null>(null);

  useEffect(() => {
    if (
      subscription &&
      subscriptionPlan &&
      subscriptionPlan.id === 'premium' &&
      subscription.is_trial === true &&
      subscription.status === 'active' && // A trial is an active subscription
      subscription.period_end
    ) {
      const trialEndDate = new Date(subscription.period_end);
      const now = new Date();
      // Ensure we are only comparing date parts, not time, or ensure consistent time handling
      // For simplicity, let's ensure 'now' is at the start of its day for comparison if trialEndDate is just a date
      // However, period_end is likely a full timestamp.
      const diffTime = trialEndDate.getTime() - now.getTime();
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      if (diffDays <= 3 && diffDays >= 0) {
        setRemainingDays(diffDays);
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    } else {
      setIsVisible(false);
    }
  }, [subscription, subscriptionPlan]); // Added subscriptionPlan to dependency array

  if (!isVisible || remainingDays === null) {
    return null;
  }

  const handleClose = () => {
    setIsVisible(false);
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-brand-primary text-white py-3 shadow-lg z-50">
      <div className="container mx-auto px-4 flex items-center justify-between"> {/* This will separate (Text+Subscribe) from (Close) */}
        {/* Group for Text and Subscribe Button */}
        <div className="flex items-center">
          <div className="text-left">
            <p className="font-semibold text-sm leading-tight">
              {remainingDays === 0
                ? '프리미엄 무료 체험이 오늘 종료됩니다!'
                : `프리미엄 무료 체험이 ${remainingDays}일 후에 종료됩니다!`}
            </p>
            <p className="text-xs leading-tight">
              혜택을 계속 누리시려면 플랜을 구독해주세요.
            </p>
          </div>
          <Button
            variant="outline"
            className="bg-white text-brand-primary hover:bg-gray-100 hover:text-brand-primary whitespace-nowrap ml-4" // Adjusted margin from text
            asChild
          >
            <Link to="/mypage#pricing">플랜 구독하기</Link>
          </Button>
        </div>

        {/* Close Button, pushed to the far right by justify-between */}
        <Button
          variant="ghost"
          size="icon"
          className="text-white hover:bg-white/20 flex-shrink-0" // flex-shrink-0 to prevent it from shrinking
          onClick={handleClose}
        >
          <X className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};

export default PremiumTrialExpiryBanner;